import styled from 'styled-components'

const DialogButtonStyle = styled.div`
  button {
    color: ${props => props.theme.primary500};
  }
`

export default DialogButtonStyle
